<template>
  <div class="modal-video">
    <v-modal :showFooterCloseButton="false" @close="closeModal()" class="modal">
      <div slot="body">
        <video
          id="video"
          autoplay
          controls
          @contextmenu="
            e => {
              e.preventDefault()
            }
          "
          disablepictureinpicture
          controlslist="nodownload"
        >
          <source :src="videoUrl" type="video/mp4" />
        </video>
      </div>
    </v-modal>
  </div>
</template>

<script>
export default {
  props: {
    videoUrl: {
      type: String,
      required: true
    }
  },
  methods: {
    closeModal(e) {
      this.$emit('closePopup', true)
    }
  }
}
</script>
